<template>
  <div id="app">
    <router-view  v-if="isReload"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{
      isReload:true,
    }
  },
  mounted(){
    // 监听屏幕变化
    window.addEventListener('resize',()=>{
      this.isReload=false;
      setTimeout(()=>{
        this.isReload=true;
      },10)
    });
  }
};
</script>
 <style>
 p{
   margin: 0;
   padding: 0;
 }
 button{
   border: none;
   outline: none;
   background: none;
   padding: 0;
   margin: 0;
 }
 dl{
   margin: 0;
   padding: 0;
 }
 </style>
<style scoped>
body{
  height: 100%;
}
html{
  height: 99vh;
}
 #app{
  width: 100%;
  height: 100%;
  overflow: hidden;
 }
</style>
